var _defs, _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartonMauvaisePosition1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "positions_porter_carton",
    "data-name": "positions porter carton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 544.16 618.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mauvaise r\xE9ponse 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 194.16,
    y: 451.1,
    width: 236,
    height: 158
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 465.16,
    cy: 218.1,
    r: 79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1122,1316s-19-178-15-215l39-130c8-34,15-53-11-84,0,0-129-113-285-127-27.35-2.45-110,39-65,136l125,179-47,259c-6,46,41,48,49,19l79-205,47-16,42,189C1080,1334,1120,1335,1122,1316Zm-83.72-182.73L991,1148l16-46c5.55-20.52,6.78-38.21-1-50L921,910l104,59c10,4,13,20,13,26l-5,70C1033,1085,1031,1100,1038.28,1133.27Z",
    transform: "translate(-768.84 -756.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartonMauvaisePosition1);
export default __webpack_public_path__ + "static/media/carton_mauvaise_position_1.ac7c61013ab814a07233124a86c28a7e.svg";
export { ForwardRef as ReactComponent };